import type { OrderSummaryPageStore } from '../types';

export class CountryBasedInfoService {
  constructor(private pageStore: OrderSummaryPageStore) {}

  public api() {
    return {
      setIsVatEuCountry: (isVatEuCountry: boolean) => this.pageStore.setState({ isVatEuCountry }),
      updateB2bTooltipVisibility: (isVisible: boolean) => {
        this.pageStore.setState({ orderSummaryShowB2bNotification: isVisible });
      },
    };
  }

  public data() {
    return {};
  }

  public handlers() {
    return {};
  }
}
